export const displayTypesField = [
    { value: "TEXT", label: 'Text' },
    { value: "SELECT", label: 'Dropdown' }
]
export const displayTypesQuestion = [
    { value: "CHECKBOX", label: 'Checkbox' },
    { value: "SELECT", label: 'Dropdown' }
]


export const sortTypes = [
    { value: "DEFAULT", label: 'Default' },
    { value: "ALPHA", label: 'Alphabetically' }
]